import $axios from '@/store/axios-instance.js';

export default {
    state: {
        userList: null,
        currentUser: null
    },
    mutations: {
        retrieveUserList(state, entityList) {
            state.userList = entityList
        },
        registerUser(state, entityList) {
            state.userList.users.push(entityList)
        },
        retrieveCurrentUser(state, entityList) {
            state.currentUser = entityList
        },
        setUserStatus(state, payload) {
            let user = state.userList.users.find(item => item.id === payload.id)
            if(user){
                user.isDisabled = payload.isDisabled
            }
        },
        editUserAttribute(state, payload) {
            let user = state.userList.users.find(item => item.id === payload.id)
            if(user){
                user.displayName = payload.displayName
            }
        },
        changeRoles(state, payload) {
            let user = state.userList.users.find(item => item.id === payload.id)
            if(user){
                user.roles = payload.roles
            }
        }
    },
    actions: {
        retrieveUserList(context, payload) {
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .get('users', {
                            params: {
                                offset: payload.offset,
                                limit: payload.limit,
                                role: payload.role,
                                isDisabled: payload.isDisabled,
                                search: payload.search
                            }
                        })
                        .then(response => {
                            context.commit('retrieveUserList', response.data)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
        retrieveCurrentUser(context, payload) {
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .get(`users/${payload}`)
                        .then(response => {
                            context.commit('retrieveCurrentUser', response.data)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
        registerUser(context, payload){
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .post('users/register', {
                            id: payload.id,
                            email: payload.email,
                            username: payload.username,
                            displayName: payload.displayName,
                            password: payload.password,
                            roles: payload.roles,
                            phone: payload.phone
                        })
                        .then(response => {
                            context.commit('registerUser', payload)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
        setUserStatus(context, payload){
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .put('users', {
                            id: payload.id,
                            isDisabled: payload.isDisabled
                        })
                        .then(response => {
                            context.commit('setUserStatus', payload)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
        editUserAttribute(context, payload){
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .put('users', {
                            id: payload.id,
                            displayName: payload.displayName
                        })
                        .then(response => {
                            context.commit('editUserAttribute', payload)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
        changeUserPassword(context, payload){
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .put('users', {
                            id: payload.id,
                            password: payload.newPassword
                        })
                        .then(response => {
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
        changeRoles(context, payload){
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .put('users', {
                            id: payload.id,
                            roles: payload.roles
                        })
                        .then(response => {
                            context.commit('changeRoles', payload)
                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (e) {
                    reject()
                }
            })
        },
    },
    getters: {
        userList(state) {
            return state.userList ?? []
        },
        currentUser(state) {
            return state.currentUser
        },
    }
}